import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return <div className={cn("setu:animate-pulse setu:rounded-md setu:bg-muted", className)} {...props} />;
}

export { Skeleton };
